import request from "./axios";

export function create_phone(data) {
  return request({ method: "post", url: "Login/GetRegisteredCode", data });
}
export function create_account(data) {
  return request({ method: "post", url: "Login/Registered", data });
}
export function accountCheck(data) {
  return request({
    method: "get",
    url: "https://kfshop.71baomu.com/UserAdmin/WorkNumber/WhetherWorkNum",
    data,
  });
}
export function login(data) {
  return request({ method: "post", url: "/Login/Login1", data });
}
export function askAccount(data) {
  return request({ method: "post", url: "/Login/AcCheck", data });
}
